module.exports = __webpack_public_path__ + "img/fast.fe178ed7.svg";